import { render, staticRenderFns } from "./access-modal.vue?vue&type=template&id=5f6e623c&"
import script from "./access-modal.vue?vue&type=script&lang=ts&"
export * from "./access-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports